// Admin build version: package.json version (injected by the start/build scripts) and the commit
// the deploy workflow passes as REACT_APP_COMMIT_SHA
const version = process.env.REACT_APP_VERSION ?? 'dev'
const commit = (process.env.REACT_APP_COMMIT_SHA ?? '').slice(0, 7)

export const ADMIN_VERSION_LABEL = commit ? `${version} · ${commit}` : version

/** "1.1.0 · 83932ed" from GET /api/version */
export const apiVersionLabel = (v: { version: string | null; commit: string | null }) =>
  [v.version ?? '?', v.commit].filter(Boolean).join(' · ')
